import React from "react"
import { connect } from "react-redux"
import Root from "#/components/views/Root"
import { getIsLoggedIn, getLoadingIsLoggedIn } from "#/redux/reducers/application"
import { getEmail } from "#/redux/reducers/userInfo"
import { fetchReduxData } from "#/redux/actions/loginActions"
import { ScrollToTop } from "../views/ScrollToTop"

type RootContainerProps = {
  isLoggedIn: boolean
  loadingIsLoggedIn: boolean
  // The signed-in member's account email (redux `userInfo.email`), threaded into
  // the consumer subscription funnel so it can prefill/lock the details step.
  // Undefined until user info loads (or when signed out) — the funnel keeps the
  // email editable in that case.
  memberEmail?: string
  fetchReduxData: () => void
}

class InternalRootContainer extends React.Component<RootContainerProps> {
  componentDidMount() {
    this.props.fetchReduxData()
  }

  render() {
    const { isLoggedIn, loadingIsLoggedIn, memberEmail } = this.props
    return (
      <ScrollToTop>
        <Root
          // @ts-expect-error the withLDProvider HOC wrapping Root erases its prop types (props collapse to IntrinsicAttributes).
          loggedIn={isLoggedIn}
          loadingIsLoggedIn={loadingIsLoggedIn}
          email={memberEmail}
        />
      </ScrollToTop>
    )
  }
}

const mapStateToProps = (state: any) => ({
  isLoggedIn: getIsLoggedIn(state),
  loadingIsLoggedIn: getLoadingIsLoggedIn(state),
  memberEmail: getEmail(state) ?? undefined
})

const RootContainer = connect(mapStateToProps, {
  fetchReduxData
})(InternalRootContainer)

export default RootContainer
